import { useEffect, useState } from 'react';
import { api } from '../utils/api';
import { useAuth } from '../context/AuthContext';

function timeAgo(date) {
  const diff = (Date.now() - new Date(date)) / 1000;
  if (diff < 60) return 'agora';
  if (diff < 3600) return Math.floor(diff/60) + 'min';
  if (diff < 86400) return Math.floor(diff/3600) + 'h';
  return Math.floor(diff/86400) + 'd';
}
function initials(nome) { return (nome||'?').split(' ').map(n=>n[0]).slice(0,2).join('').toUpperCase(); }
const COLORS = ['#EBF0FF','#E6F7F1','#FEF5E4','#FDEAEA','#F3E8FF'];
const TEXT_COLORS = ['#1028A0','#0A6B47','#8C5E00','#922020','#5B21B6'];

export default function Feed() {
  const { token, user } = useAuth();
  const [posts, setPosts] = useState([]);
  const [conteudo, setConteudo] = useState('');
  const [posting, setPosting] = useState(false);
  const [expandido, setExpandido] = useState(null);
  const [comentarios, setComentarios] = useState({});
  const [novoComentario, setNovoComentario] = useState({});

  useEffect(() => {
    api.get('/feed', token).then(data => {
      setPosts(data);
      // Marcar feed como visto
      localStorage.setItem('feed_visto', Date.now().toString());
    });
  }, [token]);

  const publicar = async (e) => {
    e.preventDefault();
    if (!conteudo.trim()) return;
    setPosting(true);
    try {
      await api.post('/feed', { conteudo }, token);
      const atualizado = await api.get('/feed', token);
      setPosts(atualizado); setConteudo('');
    } finally { setPosting(false); }
  };

  const curtir = async (postId) => {
    await api.post(`/feed/${postId}/like`, {}, token);
    setPosts(prev => prev.map(p => p.id === postId
      ? { ...p, likes: p.curtiu ? parseInt(p.likes)-1 : parseInt(p.likes)+1, curtiu: !p.curtiu }
      : p
    ));
  };

  const verComentarios = async (postId) => {
    if (expandido === postId) { setExpandido(null); return; }
    setExpandido(postId);
    const data = await api.get(`/feed/${postId}/comentarios`, token);
    setComentarios(prev => ({ ...prev, [postId]: data }));
  };

  const comentar = async (postId) => {
    const texto = novoComentario[postId];
    if (!texto?.trim()) return;
    await api.post(`/feed/${postId}/comentarios`, { conteudo: texto }, token);
    const data = await api.get(`/feed/${postId}/comentarios`, token);
    setComentarios(prev => ({ ...prev, [postId]: data }));
    setNovoComentario(prev => ({ ...prev, [postId]: '' }));
  };

  const colorIdx = (nome) => (nome||'').charCodeAt(0) % COLORS.length;
  const postsFixados = posts.filter(p => p.fixado);
  const postsSemFixado = posts.filter(p => !p.fixado);

  return (
    <div style={{padding:'20px 32px'}}>
      <div style={{marginBottom:16}}>
        <div style={{fontSize:22,fontWeight:700,letterSpacing:'-.02em'}}>Feed da Turma</div>
        <div style={{fontSize:13,color:'#6B7289',marginTop:3}}>Conquistas, dúvidas e aprendizados dos colegas</div>
      </div>

      {/* Mural fixado - múltiplos */}
      {postsFixados.map(pf => (
        <div key={pf.id} style={{background:'#FFFBEB',border:'1px solid #FDE68A',borderRadius:10,padding:14,marginBottom:12}}>
          <div style={{fontSize:11,fontWeight:700,color:'#92400E',marginBottom:6}}>📌 AVISO DO MENTOR</div>
          <div style={{fontSize:13,color:'#0B0E1A',lineHeight:1.5}}>{pf.conteudo}</div>
          <div style={{fontSize:10,color:'#92400E',marginTop:6}}>{timeAgo(pf.criado_em)}</div>
        </div>
      ))}

      {/* Publicar */}
      <div className="card" style={{marginBottom:16,padding:14}}>
        <form onSubmit={publicar}>
          <textarea className="input-field" rows={2}
            placeholder="Compartilhe uma conquista, dúvida ou aprendizado..."
            value={conteudo} onChange={e=>setConteudo(e.target.value)}
            style={{resize:'none',marginBottom:8,fontSize:13}} />
          <div style={{display:'flex',justifyContent:'flex-end'}}>
            <button className="btn-primary" type="submit" disabled={posting || !conteudo.trim()} style={{padding:'7px 16px',fontSize:12}}>
              {posting ? 'Publicando...' : 'Publicar'}
            </button>
          </div>
        </form>
      </div>

      {posts.length === 0 && (
        <div className="card" style={{textAlign:'center',padding:32,color:'#6B7289'}}>
          <div style={{fontSize:24,marginBottom:8}}>💬</div>
          Nenhuma publicação ainda. Seja o primeiro!
        </div>
      )}

      {postsSemFixado.map(post => {
        const ci = colorIdx(post.nome);
        return (
          <div key={post.id} className="card" style={{marginBottom:10,padding:14,borderLeft:post.is_mentor?'3px solid #1A2ECC':'none'}}>
            <div style={{display:'flex',alignItems:'center',gap:10,marginBottom:10}}>
              <div style={{width:32,height:32,borderRadius:8,background:post.is_mentor?'#1A2ECC':COLORS[ci],color:post.is_mentor?'#fff':TEXT_COLORS[ci],display:'flex',alignItems:'center',justifyContent:'center',fontWeight:700,fontSize:12,flexShrink:0}}>
                {post.is_mentor?'GB':initials(post.nome)}
              </div>
              <div style={{flex:1}}>
                <div style={{fontSize:13,fontWeight:600}}>
                  {post.nome}
                  {post.is_mentor && <span className="badge badge-blue" style={{marginLeft:6,fontSize:9}}>Mentor</span>}
                  {post.turma && !post.is_mentor && <span className="badge badge-blue" style={{marginLeft:6,fontSize:9}}>{post.turma}</span>}
                </div>
                <div style={{fontSize:10,color:'#6B7289'}}>{timeAgo(post.criado_em)}</div>
              </div>
            </div>
            <div style={{fontSize:13,lineHeight:1.5,color:'#0B0E1A',marginBottom:10}}>{post.conteudo}</div>
            <div style={{display:'flex',gap:16,fontSize:12,color:'#6B7289',borderTop:'0.5px solid #E4E6EF',paddingTop:8}}>
              <button onClick={()=>curtir(post.id)} style={{display:'flex',alignItems:'center',gap:4,background:'none',border:'none',cursor:'pointer',fontSize:12,color:post.curtiu?'#D63B3B':'#6B7289',fontWeight:post.curtiu?600:400}}>
                {post.curtiu?'❤️':'🤍'} {post.likes}
              </button>
              <button onClick={()=>verComentarios(post.id)} style={{display:'flex',alignItems:'center',gap:4,background:'none',border:'none',cursor:'pointer',fontSize:12,color:'#6B7289'}}>
                💬 {post.comentarios}
              </button>
            </div>

            {expandido === post.id && (
              <div style={{marginTop:10,borderTop:'0.5px solid #E4E6EF',paddingTop:10}}>
                {(comentarios[post.id]||[]).map(c => (
                  <div key={c.id} style={{display:'flex',gap:8,marginBottom:8}}>
                    <div style={{width:24,height:24,borderRadius:6,background:COLORS[colorIdx(c.nome)],color:TEXT_COLORS[colorIdx(c.nome)],display:'flex',alignItems:'center',justifyContent:'center',fontWeight:700,fontSize:9,flexShrink:0}}>
                      {initials(c.nome)}
                    </div>
                    <div style={{background:'#F4F5F9',borderRadius:'4px 8px 8px 8px',padding:'6px 10px',flex:1}}>
                      <div style={{fontSize:10,fontWeight:600,marginBottom:2}}>{c.nome}</div>
                      <div style={{fontSize:12,color:'#0B0E1A'}}>{c.conteudo}</div>
                    </div>
                  </div>
                ))}
                <div style={{display:'flex',gap:8,marginTop:8}}>
                  <input className="input-field" style={{flex:1,padding:'7px 10px',fontSize:12}}
                    placeholder="Comentário..."
                    value={novoComentario[post.id]||''}
                    onChange={e=>setNovoComentario(prev=>({...prev,[post.id]:e.target.value}))}
                    onKeyDown={e=>e.key==='Enter'&&comentar(post.id)} />
                  <button className="btn-primary" style={{padding:'7px 12px',fontSize:12}} onClick={()=>comentar(post.id)}>→</button>
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
